export default "__VITE_ASSET__CHUqj33d__"